import { Component } from '@angular/core';

@Component({
  selector: 'om-svg-calendar-outline',
  templateUrl: './svg-calendar-outline.component.html',
  styleUrls: [],
})
export class SvgCalendarOutlineComponent {}
